export const settings = {
	COLLECTIONS_URL: '/wp-json/fsd/v1/wp/video-collections/',
	MPX_PLAYLIST_URL: '/wp-json/fsd/v1/wp/mpx-related-videos',
	PARSELY_URL: '/wp-json/fsd/v1/wp/parsely-content/',
	PARSELY_URL_V2: '/wp-json/fsd/v1/wp/parsely-content-v2/',
	PODCAST_CLIPS_URL: '/wp-json/fsd/v1/wp/podcast-clips/',
	PODCAST_EPISODES_URL: '/wp-json/fsd/v1/wp/podcast-episodes/',
	MEDIA_LISTS: '/wp-json/fsd/v1/wp/media-lists/',
};

export const global = {
	FSGO_URL: 'https://www.foxsportsgo.com/',
};

export const widthRange = {
	DESKTOP: '1280+',
	LAPTOP: '1024-1279',
	TABLET: '768-1023',
	MOBILE: '-767',

	DESKTOP_MOBILE: '-767,1280+',
	TABLET_LAPTOP: '768-1279'
};

export const shareLinks = {
	FB_SHARE: 'https://www.facebook.com/sharer/sharer.php?u=',
	TWITTER_SHARE: 'https://twitter.com/intent/tweet?url=',
	GOOGLE_PLUS: 'https://plus.google.com/share?url=',
	MAIL: 'mailto:?subject='
};

export const urlFilterObj = {
    'auto_nascar' : 'nascar',
    'motorsports' : 'motor',
    'ncaa_football' : 'college-football',
};

export const ppvSettings = {
	apiKey: "xKVbwnZ794xXP6nTbXFz0HcbSfxQDo20",
	foxApi: {
		qa: "https://qa.api2.fox.com/v2.0",
		dev: "https://dev.api2.fox.com/v2.0",
		prod: "https://api2.fox.com/v2.0"
	}

}



// WEBPACK FOOTER //
// ./react-app-src/shared/constants.js